import { useMutation } from '@tanstack/react-query';
import { ChangePasswordParams } from './types';
import { Services } from './services';

export const useUser = () => {
	const changePassword = useMutation((payload: ChangePasswordParams) => Services.setChangePassword(payload));
	return { changePassword };
};
